import * as React from 'react';
import { SubtotalsListItem } from './SubtotalsListItem';
export var Fees = function (_a) {
    var fees = _a.fees, moneyFormatter = _a.moneyFormatter;
    return fees ? (React.createElement(React.Fragment, null, fees
        .filter(function (_a) {
        var price = _a.price.serializedValue;
        return !!price;
    })
        .map(function (_a, idx) {
        var name = _a.name, price = _a.price.serializedValue;
        return price !== 0 && (React.createElement(SubtotalsListItem, { key: "".concat(name, "-").concat(idx), dataHook: "fee-".concat(name), label: name, value: moneyFormatter(price) }));
    }))) : null;
};
//# sourceMappingURL=Fees.js.map